import React,{ useEffect, useState } from 'react';
import {Toast,Page } from 'react-weui';
import { getAreaList } from '@/services/home';
import styles from './styles.scss';
import Empty from '@/components/empty';
import { history,router } from 'umi';


export default (props) => {


  const area = props.location.state.area;

  const [dataList,setDataList] = useState([]);

  useEffect(() => {
    document.title = area.areaName;

    getAreaList({parentCode:area.areaCode}).then(res => {

      if (res && res.code == 200) {
        setDataList(res.data);
      }
    });
  },[]);


  return(
    <Page transition={true} infiniteLoader={false} ptr={false}>

      {dataList.length ? dataList.map(item => (
        <div className={styles.area_item} key={item.id} onClick={()=> {
          window.localStorage.setItem('select_city',JSON.stringify(item));
          history.go(-2);
        }}>
          <label>{item.areaName}</label>
          <img src={require('@/assets/arrows.png')}/>
        </div>
      )) : <Empty text={'暂无数据'}/>}

    </Page>
  )
}
